
 export const CalenderStyle ={
    arrowArabic:{
        transform:"rotate(180deg)"
    }
 }
